import { useEffect, useState } from 'react';

import {
    Box,
    Image,
    useBreakpointValue
} from '@chakra-ui/react';

export function Header({eventConfig, changePage}) {

    const isMobile = useBreakpointValue(
        {
          "base": ()=> true,
          "xl": ()=>  false
        }
    );    

    const liveAbbrev = eventConfig["liveAbbrev"];

    try {
        return (
            <Box
                bgSize="cover"
                bgImage={'url(' + process.env.PUBLIC_URL + `/images/${liveAbbrev}-bg-top.png)`}
                bgPosition="center"
                cursor="pointer"
                padding={{base: "4px", xl: "10px"}}
                bgColor="gray.900"
                width="100%"
                onClick={()=>{changePage("event-info")}}
            >
                <Image
                    borderRadius={5}
                    margin="0px auto 0px auto"
                    maxHeight={{base: "150px", md: "200px", xl: "250px"}}
                    src={process.env.PUBLIC_URL + `/images/${liveAbbrev}-site-logo.png`}
                />
            </Box>
        );
    } catch (e) {
        console.error("Header render error: ", e);
    }
}